import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { TFAStatus, TFAStatusEnum } from 'mbs-ui-shared@models';
import { TFAService } from 'mbs-ui-shared@services/tfa.service';
import { poll } from 'mbs-ui-shared@utils/operators/poll';
import { TFAStore } from '../store/tfa/tfa.store';

@Injectable({
  providedIn: 'root'
})
export class TFAFacade {
  private tfaStore = inject(TFAStore);
  private tfaService = inject(TFAService);

  public TFAStatus = toObservable(this.tfaStore.status);
  public TFAStatusLoading = toObservable(this.tfaStore.loading);

  public loadTFAStatus(force = false): void {
    this.tfaStore.loadTFAStatus(force);
  }

  public handleTFAPolling(authId: string, callback: (response: TFAStatus) => void, destroyRef: DestroyRef): void {
    this.tfaService
      .getTFAStatus(authId)
      .pipe(
        takeUntilDestroyed(destroyRef),
        poll((response) => response?.status === TFAStatusEnum.Passed)
      )
      .subscribe((response) => {
        if (response?.status === TFAStatusEnum.Passed) {
          callback(response);
        }
      });
  }
}
